"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatItem = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const Button_1 = require("../../../Button");
const Remove_1 = require("../../../Button/Remove");
const Field_1 = require("../../../Form/Field");
const tariffGroupMapper_1 = require("../../../TariffsTable/tariffGroupMapper");
const Title_1 = require("./Title");
require("./index.scss");
const className = 'passengers-seat-on-flights-item';
const SeatItem = (props) => {
    const { disabled, forbidden, infoTextData, modificators, resetSeat, price, tariffGroupCode, seatLabel, hiddenPrice, openSeatSelectionPopup, } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        tariffGroupMapper_1.tariffGroupCodeToModifierMap[tariffGroupCode],
    ]);
    const getButtonText = () => {
        if (forbidden) {
            return (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PassengersSeatsOnFlights/Item/SelectSeat/Button/Label:reservationNotPossible', defaultMessage: 'Reservation not possible' }));
        }
        if (seatLabel) {
            return (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PassengersSeatsOnFlights/Item/SelectSeat/Button/Label:selectedSeat', defaultMessage: 'Seat: {idx}', values: {
                    idx: seatLabel.split(/(\d*)(.+)/g).filter(s => s !== ''),
                } }));
        }
        return (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PassengersSeatsOnFlights/Item/SelectSeat/Button/Label:selectSeat', defaultMessage: 'Select seat' }));
    };
    const buttonText = getButtonText();
    const buttonModifiers = !forbidden ? tariffGroupMapper_1.tariffGroupCodeToModifierMap[tariffGroupCode] : undefined;
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__info` },
            react_1.default.createElement(Title_1.SeatItemTitle, { ...infoTextData })),
        react_1.default.createElement("div", { className: `${className}__button-price` },
            react_1.default.createElement("div", { className: `${className}__button` },
                react_1.default.createElement(Button_1.Button, { text: buttonText, disabled: disabled || forbidden, modificators: ['block', buttonModifiers], onClick: () => !disabled && openSeatSelectionPopup() })),
            react_1.default.createElement("div", { className: `${className}__price` },
                react_1.default.createElement(Field_1.FormField, { value: price, addon: 'CHF', modificators: 'seat-price', readOnly: true, hidden: hiddenPrice }))),
        !(forbidden || disabled) && (react_1.default.createElement("div", { className: `${className}__remove` },
            react_1.default.createElement(Remove_1.RemoveButton, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PassengersSeatsOnFlights/Item/RemoveSeat/button:label', defaultMessage: 'Remove seat' }), onClick: () => resetSeat(), hidden: !seatLabel })))));
};
exports.SeatItem = SeatItem;
//# sourceMappingURL=index.js.map